import BenefitDetailsView from "./BenefitDetailsView"
export default BenefitDetailsView
